<template>
  <v-dialog
    :value="isSalvarTicketDialogOpen"
    max-width="600px"
    persistent
  >
    <v-card class="px-4 py-6">
      <btn-close-dialog :handle-click="closeDialog"></btn-close-dialog>

      <v-card-title class="justify-center text-h5 pt-1">
        Salvar ticket
      </v-card-title>

      <v-card-text class="mt-5">
        <v-form
          ref="formRef"
          class="multi-col-validation"
          @submit.prevent="handleSubmit"
        >
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="statusTicketIdLocale"
                dense
                outlined
                label="Status"
                item-text="nome"
                item-value="id"
                hide-details="auto"
                :filled="ticketEstaFinalizado"
                :readonly="ticketEstaFinalizado"
                :items="statusTicket"
                @change="handleStatusTicketIdChange"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="aceitaPesquisaSatisfacao"
              cols="12"
              class="d-flex justify-end"
            >
              <v-checkbox
                v-model="encaminhar"
                label="Enviar para pesquisa de satisfação?"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                outlined
                color="secondary"
                class="mr-4"
                @click="closeDialog"
              >
                Cancelar
              </v-btn>

              <v-btn
                color="primary"
                type="submit"
                class="me-3 mb-2"
                :disabled="!ticketData.id || ticketEstaFinalizado"
              >
                <v-progress-circular
                  v-if="isUpdateTicketLoading"
                  class="mx-6"
                  outlined
                  indeterminate
                />
                <span v-else>Salvar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { computed, ref, watch, watchEffect } from '@vue/composition-api'
import TicketCategoriaStatusEnum from '@/models/entities/ticket/TicketCategoriaStatusEnum'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import GetTicketByIdModel from '@/models/responses/ticket/GetTicketByIdModel'
import TicketService from '@/services/modules/TicketService'
import useDialog from '@/composables/useDialog'
import { EventBus } from '@/utils/EventBus'

export default {
  components: {
    BtnCloseDialog,
  },

  emits: ['update:is-salvar-ticket-dialog-open', 'reset-ticket-data'],

  props: {
    isSalvarTicketDialogOpen: {
      type: Boolean,
      required: true,
    },
    ticketData: {
      type: GetTicketByIdModel,
      required: true,
    },
    formulariosRespostas: {
      type: Array,
      required: true,
    },
    getTickets: {
      type: Function,
      required: true,
    },
    getTicketsAndSelectFirst: {
      type: Function,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
    ticketEstaResolvido: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { formRef, loading: isUpdateTicketLoading, FORM_ERROR, closeDialog } = useDialog(emit, 'is-salvar-ticket-dialog-open')
    const statusTicket = ref([])
    const statusTicketIdLocale = ref(props.ticketData.statusId)
    const canalAceitaPesquisaSatisfacao = computed(() => props.ticketData.isTicketCanalBotOuWhatsApp())
    const encaminhar = ref(false)
    const aceitaPesquisaSatisfacao = ref(false)

    watchEffect(
      () => {
        if (props.ticketData.statusId) {
          statusTicketIdLocale.value = props.ticketData.statusId
        }
      },
    )

    async function getStatusTicket(filaId) {
      if (!filaId) return
      statusTicket.value = await TicketService.getStatusAtivos(filaId)
    }
    watch(
      () => props.ticketData.filaId,
      (current, previous) => {
        if (current !== previous) { getStatusTicket(current) }
      },
    )

    function handleStatusTicketIdChange() {
      if (!canalAceitaPesquisaSatisfacao.value) return

      const statusSelecionado = statusTicket.value.find(it => it.id === statusTicketIdLocale.value)

      if ([TicketCategoriaStatusEnum.Resolvido, TicketCategoriaStatusEnum.Finalizado].includes(statusSelecionado?.categoriaStatusId)) {
        encaminhar.value = true
        aceitaPesquisaSatisfacao.value = true
      } else {
        encaminhar.value = false
        aceitaPesquisaSatisfacao.value = false
      }
    }

    function getUpdateTicketRequestBody() {
      return {
        ...props.ticketData,
        formulariosRespostas: props.formulariosRespostas,
        statusId: statusTicketIdLocale.value,
        enviarParaPesquisaSatisfacao: encaminhar.value,
      }
    }

    async function updateTicket() {
      try {
        isUpdateTicketLoading.value = true
        await TicketService.updateTicket(props.ticketData.id, getUpdateTicketRequestBody())
        isUpdateTicketLoading.value = false

        EventBus.$emit('refetch-ticket-slas')
      } catch (err) {
        isUpdateTicketLoading.value = false
        throw err
      }
    }
    async function processamentoDepoisDeUpdateBemSucedido() {
      const statusSelecionado = statusTicket.value.find(it => it.id === statusTicketIdLocale.value)

      if ([TicketCategoriaStatusEnum.Resolvido, TicketCategoriaStatusEnum.Finalizado].includes(statusSelecionado?.categoriaStatusId)) {
        await props.getTicketsAndSelectFirst()
      } else {
        await props.getTickets()
        emit('reset-ticket-data-and-get-mensagens')
      }
      closeDialog()
    }

    async function handleSubmit() {
      if (isUpdateTicketLoading.value) return
      if (!formRef.value.validate()) {
        Vue.$toast.warning(FORM_ERROR)
        return
      }

      try {
        await updateTicket()
        await processamentoDepoisDeUpdateBemSucedido()
      } catch {
        // ignora o erro
      }
    }

    return {
      formRef,
      isUpdateTicketLoading,
      closeDialog,
      statusTicket,
      statusTicketIdLocale,
      encaminhar,
      aceitaPesquisaSatisfacao,
      handleStatusTicketIdChange,
      handleSubmit,
    }
  },
}
</script>
